const apiBaseURL = process.env.REACT_APP_API_BASE_URL
const baseURL = process.env.REACT_APP_BASE_URL

export { apiBaseURL, baseURL }
